import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrCard from 'client/components/SrCard/SrCard';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrButton, { SR_BUTTON_THEME_ADOBE_YELLOW } from 'client/components/SrButton/SrButton';
import SrLink from 'client/components/SrLink/SrLink';

const SrGetStartedPageBody = ({ location }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const history = useHistory();

  const redirectToRenterSignup = () => {
    history.push(`/start${location.search}`);
  };

  const redirectToAgentSignup = () => {
    history.push(`/signup-agent${location.search}`);
  };

  return (
    <SrBox textAlign="center">
      <SrText font="greycliff" size="40" weight="bolder" lineHeight="46px">
        {isSmallScreen ? (
          <>
            Get started
            <br />
            with Sunroom
          </>
        ) : (
          'Get started with Sunroom'
        )}
      </SrText>
      <SrBox width={isSmallScreen ? '100%' : '352px'} margin="42px auto 0 auto">
        <SrCard>
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_YELLOW}
            hasBoxShadow
            type="button"
            onClick={redirectToRenterSignup}
          >
            Renter
          </SrButton>
          <SrBox marginTop="20px" />
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_YELLOW}
            hasBoxShadow
            type="button"
            onClick={redirectToAgentSignup}
          >
            Property Manager
          </SrButton>
        </SrCard>
        <SrBox marginTop="30px" />
        <SrText font="greycliff" weight="bold">
          Already have an account? &nbsp;&nbsp;
          <SrLink to={`/login${location.search}`} color="blue300">
            Log In &gt;
          </SrLink>
        </SrText>
      </SrBox>
    </SrBox>
  );
};

SrGetStartedPageBody.propTypes = {
  location: PropTypes.object.isRequired,
};

SrGetStartedPageBody.displayName = 'SrGetStartedPageBody';

export default SrGetStartedPageBody;
